module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-6 17a1 1 0 0 1-1 1h-5v5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-5H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h5V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5h5a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/plus-3.js
// module id = 1350
// module chunks = 14